import React from "react";
import { MdOutlineTextsms } from "react-icons/md";

function Blog({ date, title, description, pic, direction }) {
  return (
    <>
      <div className='grid grid-cols-1 sm:grid-cols-2 items-center border'>
        <div className='p-5'>
          <div className='text-gray-500 flex items-center gap-1'>
            <p className='text-sm'>{date}</p>
            <p className='flex items-center text-sm gap-1'>
              <MdOutlineTextsms />3
            </p>
          </div>
          <h1 className='hover:text-primary text-xl my-3 transition-all duration-[0.5s] ease-in-out'>
            {title}
          </h1>
          <p className='text-gray-500 leading-loose'>{description}</p>
        </div>
        <div className={`${direction && "order-first w-full h-full"}`}>
          <img src={pic} alt='thumb' className='h-full w-full object-cover' />
        </div>
      </div>
    </>
  );
}

export default Blog;
